import React from "react";
import ajaxError from "../helpers/ajaxError";
import log from "../helpers/log";
import urlPrefetch from "../helpers/urlPrefetch";
import ResponsivePicture from "../helpers/ResponsivePicture.jsx";
import axios from "axios";
import xmlToJson from "../helpers/xmlToJson.js";

class SearchResultsItem extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<li>
				<a href={this.props.url}>
					<ResponsivePicture
						key={this.props.url}
						route={this.props.img}
						imgClass={this.props.imgClass}
						type="search"
						isRetina={window.isRetinadisplay}
					/>
					{this.props.name}
					{this.props.extra ? (
						<div className={this.props.extra}>
							{this.props.extra == "quality"
								? null
								: `(${this.props.valextra})`}
						</div>
					) : null}
				</a>
			</li>
		);
	}
}

class SearchResultsBlock extends React.Component {
	constructor(props) {
		super(props);
		this.urlPrefetch = new urlPrefetch();
	}
	componentDidMount() {
		this.urlPrefetch.detectarSearch();
	}
	componentWillUnmount() {
		this.urlPrefetch.unbindSearch();
	}
	render() {
		var rows = [];
		this.props.options.forEach((option, key) => {
			rows.push(
				<SearchResultsItem
					url={option.url}
					key={key}
					imgClass={option.imgClass}
					img={option.img}
					name={option.name}
					extra={option.extra}
					valextra={option["extraValue"]}
				/>
			);
		});
		return (
			<div>
				<h3 className="Main-search-result-title">
					{this.props.title}
					{this.props.extra ? (
						<a href={this.props.extra.value}>{this.props.extra.name}</a>
					) : null}
				</h3>
				<ul className="Main-search-result-list">{rows}</ul>
			</div>
		);
	}
}
class Search extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			value: "",
			showResults: false,
			hasResults: false,
			results: [],
			isLoading: false,
			ieHack:
				$("body").hasClass("explorer-10") | $("body").hasClass("explorer-11"),
		};
		this.mouseIsDownOnSearch = false;
		this.handleChange = this.handleChange.bind(this);
		this.mouseDownHandler = this.mouseDownHandler.bind(this);
		this.mouseUpHandler = this.mouseUpHandler.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleBlur = this.handleBlur.bind(this);
		this.handleFocus = this.handleFocus.bind(this);
		this.pageClick = this.pageClick.bind(this);
		this.triggerChange = this.triggerChange.bind(this);
		this.getSuggestions = this.getSuggestions.bind(this);
		
		this.urlPrefetch = new urlPrefetch();
	}
	componentDidMount() {
		this.timer = null;
		window.addEventListener("mousedown", this.pageClick, false);
	}

	pageClick(e) {
		if (this.mouseIsDownOnSearch) {
			return;
		}
		//console.log(e.target);
		if (!$(e.target).closest(".Main-search").length) {
			this.setState({ showResults: false });
		}
	}

	mouseDownHandler() {
		this.mouseIsDownOnSearch = true;
	}

	mouseUpHandler() {
		this.mouseIsDownOnSearch = false;
	}
	handleBlur(event) {
		const { currentTarget } = event;

		const { activeElement } = document;
		//log(__filename, { currentTarget });
		//log(__filename, { activeElement });
		setTimeout(() => {
			if (!this.mouseIsDownOnSearch && !currentTarget.contains(activeElement)) {
				this.setState({ showResults: false });
			}
		}, 0);
	}
	handleFocus(event) {
		this.setState({ showResults: true });
	}

	handleChange(event) {
		this.setState({ value: event.target.value });

		clearTimeout(this.timer);
		this.timer = setTimeout(this.triggerChange, window.search_timeout);
	}
	// eslint-disable-next-line class-methods-use-this
	filterSearch(entrada) {
		let largo = 0;
		let maxLargo = 0;
		const palabras = entrada.split(" ");
		let palabrasFinales = [];
		palabras.forEach((palabra) => {
			largo = palabra.length;
			if (largo > 2) {
				palabrasFinales.push(palabra);
				maxLargo = largo;
			}
		});
		palabrasFinales = palabrasFinales.join(" ");

		return [palabrasFinales, maxLargo];
	}
	triggerChange() {
		const { searchSkipTerms } = this.props;

		const { value, originalTerm="" } = this.state;


		const [valor, largo] = this.filterSearch(value);

		let terminoFiltrado = value.toLowerCase().trim();
		searchSkipTerms.forEach(element => {
			terminoFiltrado = terminoFiltrado.replace(element.toLowerCase(),"");
		});
		

		if (largo > 2) {
			this.setState({
				isLoading: true,
			});
			axios.get(links.api.search, {
				params: { term: valor, originalTerm },
			})
				.then((response) => {
					const { results } = response.data;
					if (
						results[0].options.length > 0 ||
						results[1].options.length > 0
					) {
						this.setState({
							showExtendedSearch: 0,
							results,
							hasResults: true,
							noResults: false,
							originalTerm: ""
						});
					} else if(originalTerm == "") {
						if(terminoFiltrado.length > 0) {
							this.setState({
								showExtendedSearch: 1,
								noResults: true,
								hasResults: false,
								resultsHtml: []
							});
						} else {
							this.setState({
								noResults: true,
								showExtendedSearch: 0,
								resultsHtml: [],
								hasResults: false,
								originalTerm: ""
							});
						}
					} else {
						this.setState({
							noResults: true,
							results: [],
							hasResults: false,
							originalTerm: ""
						});
					}
				})
				.catch((error) => {
					log(__filename, "Search Error");
					log(__filename, { error });
				})
				.finally(() => {
					this.setState({
						isLoading: false,
					});
				});
			this.urlPrefetch.fetchUrl(this.lfSearchPath(valor));
		}
	}
	lfSearchPath(valor) {
		// Carpeta de idioma: deriva el prefijo de links.api.search ("/es/api/predictable.json" -> "/es")
		const api = (window.links && window.links.api && window.links.api.search) || "";
		const i = api.indexOf("/api/predictable.json");
		const base = i > 0 ? api.slice(0, i) : "";
		return base + "/search/" + valor;
	}
	handleSubmit(event) {
		event.preventDefault();
		if(this.state.showExtendedSearch == 1) {
			return;
		}
		if (this.state.results[1].options.length > 0) {
			const [valor, largo] = this.filterSearch(this.state.value);
			if (window.location.href.startsWith("https")) {
				window.location = this.lfSearchPath(valor);
			} else {
				window.location =
					window.location.origin.replace("http://", "https://") +
					this.lfSearchPath(valor);
			}
		}
	}
	getSuggestions() {
		const { getGoogleSuggestQueryApi, lang } = this.props;
		const { value } = this.state;

		

		axios
			.get(getGoogleSuggestQueryApi, {
				params: {
					term: value,
					hl: lang,
				}
				
			})
			.then((data) => {
				const suggestions = data.data;

				if(suggestions.length > 0) {
					this.setState((state) => { return { 
						value: suggestions[0],
						originalTerm: state.value,
						showExtendedSearch: state.showExtendedSearch+1
					}});
					this.triggerChange();
					
				} else {
					this.setState({
						showExtendedSearch: 2,
						noResults: true
					})
				}

			}).catch(err => {
				this.setState({
					showExtendedSearch: 2
				})
			})
	}
	render() {
		var rows = [];
		if (this.state.hasResults) {
			this.state.results.forEach((result, key) => {
				rows.push(
					<SearchResultsBlock
						key={key}
						options={result.options}
						title={result.title}
						extra={result.titleExtra}
					/>
				);
			});
		}
		return (
			<div
				tabIndex="0"
				onBlur={this.handleBlur}
				onMouseEnter={this.mouseDownHandler}
				onMouseLeave={this.mouseUpHandler}
			>
				<form autoComplete="off" onSubmit={this.handleSubmit}>
					<input
						name="data[term]"
						autoComplete="off"
						value={this.state.value}
						onFocus={this.handleFocus}
						onChange={this.handleChange}
						placeholder={translate.search_games}
						aria-label={translate.search_games}
						className="search"
						type="text"
						id="term"
					/>
				</form>
				{this.state.showResults ? (
					<div className="Main-search-result">
						<i className="fa fa-caret-up" aria-hidden="true" />
						{this.state.showExtendedSearch === 1 ? (
							<button
								className="moreResultsButton"
								onClick={this.getSuggestions}
								type="button"
							>
								{translate.more_results}
							</button>
						) : null}
						{this.state.hasResults ? (
							<div>{rows}</div>
						) : this.state.isLoading ? (
							<i className=" fa fa-circle-o-notch fa-spin fa-fw "></i>
						) : (
							<p className="loading">{this.state.noResults ? "" : translate.search_placeholder_text}</p>
						)}
						<p className="loading">{this.state.noResults && this.state.showExtendedSearch != 1 ? translate.no_results  : ""} </p>
						

						{this.state.ieHack ? (
							<iframe
								id="fake"
								frameBorder="0"
								width="1"
								height="1"
								src="about:blank"
							/>
						) : null}
					</div>
				) : null}
			</div>
		);
	}
}

export default Search;
